module.exports = __webpack_public_path__ + "img/mastercard.0162bca2.svg";